export const isMobile = () => {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) return true
    else return false
}


export const checkTURNServer = (turnConfig, timeout) => {

    return new Promise(function(resolve, reject) {

        setTimeout(function() {
            if (promiseResolved) return;
            resolve(false);
            promiseResolved = true;
        }, timeout || 5000);

        var promiseResolved = false,
            myPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection //compatibility for firefox and chrome
            ,
            pc = new myPeerConnection({ iceServers: [turnConfig] }),
            noop = function() {};
        pc.createDataChannel(""); //create a bogus data channel
        pc.createOffer(function(sdp) {
            if (sdp.sdp.indexOf('typ relay') > -1) { // sometimes sdp contains the ice candidates...
                promiseResolved = true;
                resolve(true);
            }
            pc.setLocalDescription(sdp, noop, noop);
        }, noop); // create offer and set local description
        pc.onicecandidate = function(ice) { //listen for candidate events
            if (promiseResolved || !ice || !ice.candidate || !ice.candidate.candidate || !(ice.candidate.candidate.indexOf('typ relay') > -1)) return;
            promiseResolved = true;
            resolve(true);
        };
    });
}


export const getCurrency = (currency) => {
    if (currency == 'ghs') {
        return '¢'
    } else if (currency == 'ngn') {
        return '₦'
    } else if (currency == 'usd') {
        return '$'
    }
}

export const size2Byte = (size) => {
    let i = Math.floor(Math.log(size) / Math.log(1024))
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}

export function formatFileSize(size) {
    let i = Math.floor(Math.log(size) / Math.log(1024))
    return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'kB', 'MB', 'GB', 'TB'][i]
}

export function mapFields(options) {
    const object = {};
    for (let x = 0; x < options.fields.length; x++) {
        const field = [options.fields[x]];
        object[field] = {
            get() {
                return this.$store.state[options.base][field];
            },
            set(value) {
                this.$store.commit(options.mutation, {
                    [field]: value
                });
            }
        };
    }
    return object;
}

export function uniqueKey() {
    return Math.random().toString(36).substr(2, 9)
}


import _ from "lodash";

export const transformData = (info, name) => {
    let labels = [];
    let data = [];

    const sorted = _.fromPairs(
        _.sortBy(_.toPairs(_.countBy(info, name)), 1).reverse()
    );


    const top5 = _.slice(Object.entries(sorted), 0, 5);

    top5.forEach((item, index) => {
        labels[index] = `${item[0]} ${item[1]}`;
        data[index] = item[1];
    });

    return {
        labels,
        data,
        key: uniqueKey()
    };
}


export const percentageData = (info, name) => {
    let data = [];

    const sorted = _.fromPairs(
        _.sortBy(_.toPairs(_.countBy(info, name)), 1).reverse()
    );

    const top5 = _.slice(Object.entries(sorted), 0, 5);

    const total = top5.reduce((acc, val) => acc + val[1], 0)

    top5.forEach((item, index) => {
        data[index] = {
            'name': item[0],
            'count': item[1],
            'percentage': ((item[1] / total) * 100).toFixed(0)
        }
    });

    return data;
}

const facebookAppId = process.env.VUE_APP_FACEBOOK_APP_ID;

export function initFacebookSdk() {
    return new Promise(resolve => {
        // wait for facebook sdk to initialize before starting the vue app
        window.fbAsyncInit = function() {
            FB.init({
                appId: facebookAppId,
                cookie: true,
                xfbml: true,
                version: 'v11.0'
            });

            // auto authenticate with the api if already logged in with facebook
            FB.getLoginStatus(({ authResponse }) => {
                if (authResponse) {
                    //accountService.apiAuthenticate(authResponse.accessToken).then(resolve);
                } else {
                    resolve();
                }
            });
        };

        // load facebook sdk script
        (function(d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    });
}